import { createContext, useState } from 'react';
import { LoadingPage } from '../components/LoadingPage';
import { LoadingContent } from '../components/LoadingContent';

export const LoadingContext = createContext({
    isLoadingPage: false,
    setIsLoadingPage: (isLoadingPage: boolean) => {},
    isLoadingContent: false,
    setIsLoadingContent: (isLoadingContent: boolean) => {}
});

export const LoadingProvider = ({ children }) => {
    const [isLoadingPage, setIsLoadingPage] = useState<boolean>(false);
    const [isLoadingContent, setIsLoadingContent] = useState<boolean>(false);

    return (
        <LoadingContext.Provider
            value={{
                isLoadingPage: isLoadingPage,
                setIsLoadingPage: setIsLoadingPage,
                isLoadingContent: isLoadingContent,
                setIsLoadingContent: setIsLoadingContent
            }}
        >
            {children}
            {isLoadingPage && <LoadingPage />}
            {isLoadingContent && <LoadingContent />}
        </LoadingContext.Provider>
    );
};
